import { SVGProps } from 'react';

export default function Location9(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3389)">
        <path
          d="M11.6667 15H8.33333C7.41417 15 6.66667 14.2525 6.66667 13.3333V9.99998C6.66667 9.08081 7.41417 8.33331 8.33333 8.33331H11.6667C12.5858 8.33331 13.3333 9.08081 13.3333 9.99998V13.3333C13.3333 14.2525 12.5858 15 11.6667 15ZM8.33333 9.99998V13.3333H11.6683L11.6667 9.99998H8.33333ZM15.8333 20H4.16667C1.86917 20 0 18.1308 0 15.8333V8.10331C0 6.71581 0.686667 5.42415 1.83667 4.64915L7.66917 0.712478C8.35684 0.245664 9.16885 -0.00390625 10 -0.00390625C10.8312 -0.00390625 11.6432 0.245664 12.3308 0.712478L18.1642 4.64915C18.7299 5.03025 19.1933 5.54464 19.5134 6.14699C19.8335 6.74934 20.0007 7.42117 20 8.10331V15.8333C20 18.1308 18.1308 20 15.8333 20ZM10 1.66414C9.50128 1.66458 9.01416 1.81466 8.60167 2.09498L2.76833 6.03081C2.42886 6.25926 2.1508 6.56773 1.95868 6.92901C1.76655 7.29029 1.66627 7.69329 1.66667 8.10248V15.8325C1.66667 17.2108 2.78833 18.3325 4.16667 18.3325H15.8333C17.2117 18.3325 18.3333 17.2108 18.3333 15.8325V8.10331C18.3333 7.27081 17.9217 6.49581 17.2325 6.03165L11.3983 2.09498C10.9858 1.81466 10.4987 1.66458 10 1.66414Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3389">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
